import {
    TablecontextActions,
    TablecontextActionTypes,
    TableContextState,
} from "#store/tablecontext/tableContextTypes";
import { differenceWith } from "lodash";

const initialState: TableContextState = {
    contexts: [],
};

export function tableContextReducer(
    state: TableContextState = initialState,
    action: TablecontextActionTypes
) {
    switch (action.type) {
        // case TableActionTypes.UPDATE_RESULT:
        // case TableActionTypes.CREATE_RESULT: {
        //     const filter = state.tableResults.filter(value => {
        //         return !(
        //             value.sql === action.payload.sql &&
        //             value.queryType === action.payload.queryType
        //         );
        //     });
        //     filter.push(action.payload);
        //     return { ...state, tableResults: filter };
        // }
        //
        // case TableActionTypes.DELETE_RESULT: {
        //     const removed = state.tableResults.filter(value => {
        //         return (
        //             value.sql === action.payload.sql &&
        //             value.queryType === action.payload.queryType
        //         );
        //     });
        //     return { ...state, tableResults: removed };
        // }
        case TablecontextActions.FETCHED_CONTEXT:
            // remove items if it has same tables and query
            const filtered = state.contexts.filter(value => {
                const querySame = value.query === action.payload.query;
                const sameLength =
                    value.tableIds.length === action.payload.tableIds.length;
                const diffWith = differenceWith(
                    value.tableIds,
                    action.payload.tableIds
                );
                return !querySame || !sameLength || !(diffWith.length === 0);
                // return querySame && sameLength && diffWith.length === 0;
            });
            filtered.push(action.payload);
            return {
                ...state,
                contexts: filtered,
            };
        default:
            return state;
    }
}
